export default __webpack_public_path__ + "static/media/ic_time.90dd3b64.svg";